/* @refresh reload */
import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";
import App from "./App";
import Dashboard from "./routes/Dashboard";
import Members from "./routes/Members";
import "./styles/globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

render(
  () => (
    <Router root={App}>
      <Route path="/" component={Dashboard} />
      <Route path="/members" component={Members} />
    </Router>
  ),
  root,
);
